
  import '@strudel/repl';
  import {
    fullInitialize,
    getAudioContext
  } from '/assets/js/dsonic-strudel.js';

  let strudelEditor = null;

  async function initialize() {
    console.log('Initialize starting...');
    strudelEditor = document.getElementById('strudel-editor');
    window.strudelEditor = strudelEditor;

    await new Promise(resolve => {
      if (strudelEditor.editor) {
        resolve();
      } else {
        const checkReady = setInterval(() => {
          if (strudelEditor.editor) {
            clearInterval(checkReady);
            resolve();
          }
        }, 100);
        setTimeout(() => {
          clearInterval(checkReady);
          resolve();
        }, 10000);
      }
    });

    // Initialize DSonic with both template and engine sounds
    // Overview page uses maxTemplates: 3 to limit registered variants
    await fullInitialize({ registerTemplates: true, registerEngines: true, maxTemplates: 3 });
  }

  const playBtn = document.getElementById('play-btn');
  const stopBtn = document.getElementById('stop-btn');

  playBtn.addEventListener('click', async () => {
    const ctx = getAudioContext();
    if (ctx.state === 'suspended') {
      await ctx.resume();
    }
    if (strudelEditor?.editor?.toggle) {
      await strudelEditor.editor.toggle();
      playBtn.classList.add('playing');
    }
  });

  stopBtn.addEventListener('click', () => {
    if (strudelEditor?.editor?.stop) {
      strudelEditor.editor.stop();
      playBtn.classList.remove('playing');
    }
  });

  const updateBtn = document.getElementById('update-btn');
  updateBtn.addEventListener('click', async () => {
    const ctx = getAudioContext();
    if (ctx.state === 'suspended') {
      await ctx.resume();
    }
    if (strudelEditor?.editor?.evaluate) {
      await strudelEditor.editor.evaluate();
      playBtn.classList.add('playing');
    } else if (strudelEditor?.editor?.repl?.evaluate) {
      await strudelEditor.editor.repl.evaluate();
      playBtn.classList.add('playing');
    } else if (strudelEditor?.editor?.toggle) {
      await strudelEditor.editor.toggle();
      playBtn.classList.add('playing');
    }
  });

  document.addEventListener('start-repl', () => {
    playBtn.classList.add('playing');
  });

  document.addEventListener('keydown', async (e) => {
    if (e.ctrlKey && e.key === 'Enter') {
      const ctx = getAudioContext();
      if (ctx.state === 'suspended') {
        await ctx.resume();
      }
    }
    if (e.ctrlKey && e.key === 'u') {
      e.preventDefault();
      updateBtn.click();
    }
  }, { capture: true });

  const errorDisplay = document.getElementById('error-display');
  const errorMessage = document.getElementById('error-message');
  const errorDismiss = document.getElementById('error-dismiss');

  function showError(message) {
    errorMessage.textContent = message;
    errorDisplay.classList.add('visible');
  }

  function hideError() {
    errorDisplay.classList.remove('visible');
  }

  errorDismiss.addEventListener('click', hideError);

  window.addEventListener('error', (event) => {
    if (event.message && !event.message.includes('ResizeObserver')) {
      showError(event.message);
    }
  });

  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason?.message) {
      showError(event.reason.message);
    } else if (typeof event.reason === 'string') {
      showError(event.reason);
    }
  });

  document.addEventListener('start-repl', hideError);

  initialize().catch(err => {
    console.error('DSonic initialization error:', err);
    showError('Initialization error: ' + err.message);
    window.isInitialized = true;
  });
